import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const getExpiredEmpDocsSlice = createSlice({
  name: "ExpiredDocs",

  initialState: { empExpDocsData: [], expiredDocLoader: false, expiredDocRefreshData : false },
  reducers: {
    setEmployeeExpiredDocs: (state: any, action: PayloadAction<any>) => {
      state.empExpDocsData = action.payload;
    },
    setEmployeeExpiredDocsLoader: (state: any, action: PayloadAction<any>) => {
      state.expiredDocLoader = action.payload;
    },
    setExpiredDocsRefreshData: (state: any, action: PayloadAction<any>) => {
      state.expiredDocRefreshData = action.payload;
    },
    

    resetEmployeeExpDocs: (state: any) => {
      state = [];
    },
  },
});

export const {
  setEmployeeExpiredDocs,
  resetEmployeeExpDocs,
  setEmployeeExpiredDocsLoader,
  setExpiredDocsRefreshData,
} = getExpiredEmpDocsSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default getExpiredEmpDocsSlice.reducer;
